import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import globalValues from "../../../../../utilities/apiRequests/globalValues";

const libraries = ['places'];

const MapLocationComponent = ({ lat, lng }) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: globalValues.keys.REACT_APP_LOCATION_GOOGLE_API_KEY,
        libraries,
    });

    const containerStyle = {
        width: "100%",
        height: "114px",
        borderRadius: "16px"
    };

    const center = {
        lat: lat,
        lng: lng,
    };

    if (!isLoaded) return <div>Loading map...</div>;

    return (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
            <Marker position={center} />
        </GoogleMap>
    );
};

export default MapLocationComponent;